var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.146 17.147a.5.5 0 1 0 .708.707L12 12.707l5.148 5.148a.5.5 0 0 0 .707-.707L12.707 12l5.147-5.146a.5.5 0 1 0-.707-.708L12 11.293 6.855 6.148a.5.5 0 1 0-.707.707L11.293 12l-5.147 5.147Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.146 17.147a.5.5 0 1 0 .708.707L12 12.707l5.148 5.148a.5.5 0 0 0 .707-.707L12.707 12l5.147-5.146a.5.5 0 1 0-.707-.708L12 11.293 6.855 6.148a.5.5 0 1 0-.707.707L11.293 12l-5.147 5.147Z",
    fill: "#747F88"
  })));
};

export default SvgClose;